import { vueAppWithPinia } from "../Common/vueApp";
import PublicFightsQueueApp from "./PublicFightsQueueApp.vue";

export default vueAppWithPinia(PublicFightsQueueApp);
